<template>
  <div id="public-layout">
    <div id="content-wrap">
      <Nav />
      <div class="under-nav"></div>
      <router-view />
    </div>
    <footer id="footer">
      <Footer />
    </footer>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Layout",
  components: {
    Nav,
    Footer,
  },
};
</script>

<style>
.under-nav {
  height: 100.641px;
}
</style>
